import { combineReducers } from 'redux-immutablejs';

import contactReducer from './contact';
import documentReducer from './document';
import exemptionReducer from './exemption';
import eventReducer from './event';
import hearingReducer from './hearing';
import taxingUnitReducer from './taxingUnit';
import taxingUnitGroupsReducer from './taxingUnitGroups';
import versionReducer from './version';
import globalReducer from './global';
import documentUploadReducer from './documentUpload';

export default combineReducers({
  contact: contactReducer,
  document: documentReducer,
  exemption: exemptionReducer,
  event: eventReducer,
  hearing: hearingReducer,
  taxingUnit: taxingUnitReducer,
  taxingUnitGroups: taxingUnitGroupsReducer,
  version: versionReducer,
  global: globalReducer,
  documentUpload: documentUploadReducer,
});
